import { FC } from "react";

import { Text } from "uikit/Typography";

import { BadgeProps } from "./types";
import { BadgeBase, StyledCloseIconThin } from "./styles";

const Badge: FC<BadgeProps> = ({ $variant = "blue", $showDot, onClose, children, ...rest }) => {
  return (
    <BadgeBase $variant={$variant} $showDot={$showDot} onClose={onClose} {...rest}>
      <Text component="span" $fs="t12" $fw={"medium"}>
        {children}
      </Text>
      {onClose && (
        <StyledCloseIconThin onClick={onClose} data-testid={`${$variant}-badge-close-icon`} />
      )}
    </BadgeBase>
  );
};

export default Badge;
